import { useSelector } from "react-redux";
import Breadcrumbs from "src/components/bread-crumbs/Breadcrumbs";
import Button from "src/components/buttons/Button";
import { InputElement } from "src/components/inputs/Input";
import { AddIcon } from "src/icons/AddIcon";
import { ExportIcon } from "src/icons/ExportIcon";
import { RefreshIcon } from "src/icons/RefreshIcon";
import SearchIcon from "src/icons/SearchIcon";
import { hasEditAccess } from "src/redux/selectors/app";

type TabHeaderTypes = {
  label: string;
  subLabel?: string;
  onRefresh?: () => void;
  buttonLabel?: string;
  createButton?: {
    label: string;
    onClick: () => void;
  };
  exportButton?: {
    label: string;
    onClick: () => void;
  };
  printButton?: {
    label: string;
    onClick: () => void;
  };
  search?: {
    placeholder?: string;
    value: string | undefined;
    onChange: (val: string) => void;
  };
  showBreadcrumb?: boolean;
};

const TabHeader = ({
  onRefresh,
  label,
  subLabel,
  buttonLabel,
  createButton,
  exportButton,
  printButton,
  search,
  showBreadcrumb,
}: TabHeaderTypes) => {
  const hasEditPermission = useSelector(hasEditAccess);

  return (
    <div className="flex items-center justify-between gap-5 flex-wrap">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className="text-26px font-bold">{label}</span>
          {/* <InfoTooltip content="It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters," /> */}
        </div>
        {subLabel && (
          <span className="text-blue-dark text-sm font-light leading-[22px]">
            {subLabel}
          </span>
        )}
        {showBreadcrumb && (
          <div className="flex">
            <Breadcrumbs />
          </div>
        )}
      </div>
      <div className="flex flex-wrap gap-3">
        {search && (
          <SearchText
            value={search.value}
            onChange={(val) => search.onChange(val)}
          />
        )}
        {exportButton && (
          <Button
            onClick={exportButton?.onClick}
            text={exportButton.label ?? "Export"}
            className="h-[40px] !rounded-full shrink-0"
            icon={() => <ExportIcon color={"#28303F"} />}
          />
        )}
        {/* {printButton && (
          <Button
            onClick={printButton?.onClick}
            text={printButton.label ?? "Print"}
            className="h-[40px] !rounded-full shrink-0"
            icon={() => <PrintIcon color={"#28303F"} />}
          />
        )} */}
        {createButton && (
          <Button
            onClick={createButton?.onClick}
            text={createButton.label}
            className="h-[40px] !rounded-full shrink-0"
            icon={(color) => <AddIcon color={color} />}
            isDisabled={!hasEditPermission}
            tooltip={
              hasEditPermission ? "" : "You don't have permission to create."
            }
            primary
          />
        )}
        {onRefresh && (
          <Button
            onClick={onRefresh}
            text="Refresh"
            className="h-[40px] !rounded-full shrink-0"
            icon={(color) => <RefreshIcon color={"#28303F"} />}
          />
        )}
      </div>
    </div>
  );
};

export default TabHeader;

const SearchText = ({
  value,
  onChange,
}: {
  value: string | undefined;
  onChange: (val: string) => void;
}) => {
  return (
    <InputElement
      className="!h-[40px] !rounded-[25px] !w-[280px] bg-white placeholder:text-lg"
      placeholder="Search..."
      icon={(className) => <SearchIcon className={className} color="#8C8C8C" />}
      onChange={(e) => onChange(e.target.value)}
      value={value}
    />
  );
};
